module.exports = __webpack_public_path__ + "media/images/front/icons/register-84be3a186f7d1ab514517112840559e7.png";